export default __webpack_public_path__ + "static/media/preloader-a.9fbca22b.png";